module.exports = __webpack_public_path__ + "img/placeholder.b2e8f308.svg";